import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table, Badge, Button } from 'react-bootstrap';

const statusColor = (estado) => {
  if (!estado) return 'secondary';
  if (estado.toLowerCase().includes('vigente')) return 'success';
  if (estado.toLowerCase().includes('cancelado')) return 'danger';
  if (estado.toLowerCase().includes('no encontrado')) return 'warning';
  return 'info';
};

const badgeValue = (value, type) => {
  if (!value) return null;
  if (type === 'ok') {
    return value === 'true' ? <Badge bg="success">Sí</Badge> : <Badge bg="danger">No</Badge>;
  }
  return <Badge bg={statusColor(value)}>{value}</Badge>;
};

const EstatusCfdiModal = ({ show, onHide, info }) => (
  <Modal show={show} onHide={onHide} centered size="md" backdrop="static">
    <Modal.Header closeButton style={{ background: '#f8f9fa' }}>
      <Modal.Title>
        <i className="fas fa-file-invoice-dollar me-2 text-primary"></i>
        Detalle de Estatus CFDI
      </Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ background: '#f4f6fb' }}>
      {info ? (
        <Table bordered hover responsive size="sm" className="mb-0 shadow-sm bg-white rounded">
          <tbody>
            <tr>
              <th style={{ width: '40%' }}>Código</th>
              <td>{info.codigo}</td>
            </tr>
            <tr>
              <th>Consulta OK</th>
              <td>{info.consultaOk}</td>
            </tr>
            <tr>
              <th>Código Estatus</th>
              <td>{info.codigoEstatus}</td>
            </tr>
            <tr>
              <th>Es Cancelable</th>
              <td>{info.esCancelable}</td>
            </tr>
            <tr>
              <th>Estado</th>
              <td>{badgeValue(info.estado)}</td>
            </tr>
            <tr>
              <th>Estatus CFDI</th>
              <td>{info.estatusCfdi}</td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <div className="text-danger">No se pudo leer la información del XML.</div>
      )}
    </Modal.Body>
    <Modal.Footer style={{ background: '#f8f9fa' }}>
      <Button variant="primary" onClick={onHide}>
        <i className="fas fa-times me-1"></i> Cerrar
      </Button>
    </Modal.Footer>
  </Modal>
);

EstatusCfdiModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  info: PropTypes.object
};

export default EstatusCfdiModal;
